import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

export interface SystemRole {
  system_role_id: string;
  role: string;
}

/**
 * Hook to fetch all available system roles
 */
export function useSystemRoles() {
  return useQuery<SystemRole[]>({
    queryKey: ['system-roles'],
    staleTime: 5 * 60 * 1000, // 5 minutes - roles don't change often
    queryFn: async () => {
      const { data, error } = await supabase
        .from('system_roles')
        .select('system_role_id, role')
        .order('role', { ascending: true });

      if (error) {
        console.error('[useSystemRoles] Error loading roles:', error);
        throw error;
      }

      return data || [];
    },
  });
}
